import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";

export class TheCryptAnimationConfig {
    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles:50,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static bigWinAnticipationWiggle2 = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles: 40,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });

    public static capWinAnticipationWiggleX = CustomWiggle.create("Wiggle.easeOut", {wiggles:70, type:"easeOut"});
    public static capWinAnticipationWiggleY = CustomWiggle.create("Wiggle.easeOut", {wiggles:70, type:"easeOut"});
}